/**
 * Role-based route guard: installer-only routes.
 * Homeowners who hit /fleet, /notifications, or /reports are redirected to /app (Dashboard).
 */
import { Navigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';

interface InstallerOnlyRouteProps {
  children: React.ReactNode;
}

export function InstallerOnlyRoute({ children }: InstallerOnlyRouteProps) {
  const { isInstaller, loading } = useApp();

  if (loading) {
    return null;
  }

  if (!isInstaller) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
